import { Icon } from "@evergis/ui";
import React, { FC } from "react";

import { MessageTitle } from "../../Import/styled";
import { ErrorMessageContainer, ErrorMessageWrapper } from "./styled";
import { useErrorResponse } from "./useErrorResponse";

export interface ResponseError extends Error {
  response?: Response;
}

export interface ErrorMessageProps {
  error: ResponseError;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ error }) => {
  const responseError = useErrorResponse(error);

  return (
    <ErrorMessageWrapper>
      <ErrorMessageContainer>
        <Icon kind="alert" />
        <MessageTitle>{responseError ? responseError?.title || responseError?.ErrorType : error?.message}</MessageTitle>
        {responseError &&
          responseError?.errors &&
          Object.entries(responseError?.errors).map(([prop, value]) => (
            <MessageTitle>
              {prop}:&nbsp;
              {value}
            </MessageTitle>
          ))}
        {responseError && responseError?.ExceptionMessage && (
          <MessageTitle>{responseError?.ExceptionMessage}</MessageTitle>
        )}
      </ErrorMessageContainer>
    </ErrorMessageWrapper>
  );
};
